// import BetBuilderPlaceMarketModel from './betbuilder-place-market.model';
import { ITEM_TYPES } from '../index';
/**
 * Bet builder item in place request
 */
export default class AlgoBetBuilderPlaceModel {
  constructor({algoMatch, match}) {
    /**
     * Match id
     * @type {number}
     */
    // this.mid = algoMatch.algoItem.itemType === ITEM_TYPES.LIVE ? parseInt(match.betRadarId, 10) : match.matchId;
    this.mid = match.matchId;
    /**
     * Sport id
     * @type {number}
     */
    this.sid = match.sportId;
    /**
     * isLive
     * @type {boolean}
     */
    this.il = algoMatch.algoItem.itemType === ITEM_TYPES.LIVE;
    /**
     * Price
     * @type {number}
     */
    this.pr = algoMatch.algoItem.odd;
    /**
     * Tournament ID
     * @type {number}
     */
    this.tid = match.tournamentId;
    /**
     * Tournament name
     * @type {string}
     */
    this.tn = match.tournamentName,
    /**
     * Home team
     * @type {string}
     */
    this.ht = match.homeTeam,
    /**
     * Away team
     * @type {string}
     */
    this.at = match.awayTeam,
    /**
     * BetRadar ID
     * @type {string}
     */
    this.i = match.betRadarId,
    /**
     * outcomeInfos[]
     * @type {Array}
     */
    this.outi = algoMatch.singles.map(it => ({
      oid: it.marketId,
      otoid: it.outcomeId,
      odd: +it.odd,
      issbv: !!it.sbv,
      // TODO: check if we need to send true also for new player markets
      ipm: it.itemType === ITEM_TYPES.PLAYER,
      sbv: it.sbv || '',
      id: it.identifier || null
    }));
  }
}
